import React from 'react';
import t from 'tcomb-form';
import _ from 'lodash';

import imgResolver from '../utils/img-resolver';

import baseFormFactory from './BaseForm';
import types from './validators/index';
import {ValidatonError} from '../resources/GenericResource';
import CalculationModal from '../components/CalculationModal';
import NumberInput from '../components/NumberInput';

const notEmptyStr = t.subtype(t.Str, (x) => { return x !== null && x !== undefined && x !== '' });

const ShiftPositionsFormModel = t.struct({
    position: t.Str,
    positionDescription: t.maybe(t.Str),
    workers_needed: types.positiveInt,
    rate: notEmptyStr,
    dresscode: t.maybe(t.Str),
    meterText: t.maybe(t.Str)
});

class FormLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCalculationModal: false
        }
    }

    toggleCalculationModal() {
        this.setState({
            showCalculationModal: !this.state.showCalculationModal
        });
    }

    render() {
        const {inputs, value, potentialCandidates} = this.props;

        return (
            <div className="position-form-content">
                <div className="col col-positions">
                    <div className="positions-content">
                        <img className="positions-img" src={require('../styles/images/create_shift_person.svg')} alt="" />
                        <h3 className="positions-title">Positions</h3>
                        <div className="form-control form-control-select">
                            {inputs.position}
                        </div>
                        {inputs.positionDescription}
                        <div className="positions-description">
                            <p>{value.positionDescription ? value.positionDescription : ""}</p>
                        </div>
                    </div>
                </div>
                <div className="col col-misc">
                    <div className="row-1">
                        <label className="form-control form-control-text form-control-workers">
                            <h3 className="label-title">Number of workers</h3>
                            {inputs.workers_needed}
                        </label>

                        <label className="form-control form-control-text form-control-hourly">
                            <h3 className="label-title">Hourly rate</h3>
                            {inputs.rate}
                            <span className="tooltip">Enter gross rate here. Taxes will be deducted from it based on local laws.</span>
                        </label>
                    </div>
                    <div className="row-2">
                        <label className="form-control form-control-text">
                            <h3 className="label-title">Dresscode</h3>
                            {inputs.dresscode}
                        </label>
                    </div>
                    <div className="row-3">
                        <div className="meter-small">
                            <div className="meter-arrow" style={{transform: 'rotate(' + value.degrees + 'deg)'}}></div>
                            {inputs.degrees}
                        </div>
                        <div className="meter-info">
                            {inputs.meterText}
                            <div className="info-title">{value.meterText}</div>
                            <div className="info-potential-people">Potential workers: <span className="orange">{potentialCandidates}</span></div>
                            <a className="info-link-how" onClick={this.toggleCalculationModal.bind(this)} href="#">How is this calculated?</a>
                        </div>
                        <CalculationModal toggleModal={this.toggleCalculationModal.bind(this)} isVisible={this.state.showCalculationModal} />
                    </div>
                </div>
            </div>
        );
    }
}

function makeLayout(locals) {
    return <FormLayout potentialCandidates={this.props.potentialCandidates} {...locals}/>
}

const Form = baseFormFactory(ShiftPositionsFormModel, true, true);

class ShiftPositionsForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        let value = props.initialFormData;

        this.state = {
            isValid,
            value,
            receivedProps: false,
            arrowDisabled: false,
            minValue: 1,
            minWorkers: value.minWorkers || 1,
            disabled: props.disabled
        };
    }

    componentWillReceiveProps() {
        if (!this.state.receivedProps && this.props.initialFormData.degrees) {
            const value = this.props.initialFormData;
            this.setState({value, receivedProps: true});
        }
    }

    postValidate(state, value) {
        if (value && parseFloat(value.rate) < this.state.minValue) {
            state.isValid = false;
            state.errors = _.merge({}, state.errors, {'hourly_rate': 'Hourly rate too low.'});
        }
        if (value && this.props.disabled && value.workers_needed < this.state.minWorkers) {
            state.isValid = false;
            state.errors = _.merge({}, state.errors, {'workers': "Can't reduce number of workers anymore."});
        }
        return state;
    }

    buildSelectOptions(positions) {
        // [{value: 'x', text: 'y'}, ...]
       return positions.map( pos => {
            return {value: pos.id, text: pos.name};
        });
    }

    changeMeter(input, position) {
        const maxDeg = 187;
        const minDeg = -17;
        const bestPay = position.default_pay*2;
        let degrees = 0;
        let text = '';
        if (bestPay == 0 || input/bestPay <= 0) {
            degrees = minDeg;
            text = 'Hourly rate too low';
        } else if (input / bestPay >= 1) {
            degrees = maxDeg + minDeg;
            text = 'Awesome hourly rate!';
        } else {
            degrees = (input / bestPay)*maxDeg - 17;
            if(degrees < 36) {
                text = 'Hourly rate too low';
            } else if (degrees < 109) {
                text = 'Hourly rate is average';
            } else {
                text = 'Awesome hourly rate!';
            }
        }
        return {degrees: degrees, meterText: text};
    }

    onChange(value, path) {
        let arrowDisabled = false;

        if (path.indexOf('position') > -1) {
            if (value.position == "") {
                value.positionDescription = "";
                value.degrees = -17;
                value.meterText = "Pay too low";
            } else {
                const descItem = _.find(this.props.positions, function(pos) {
                    return pos.id == value.position;
                });
                value.positionDescription = descItem.description;
                const result = this.changeMeter(value.rate, descItem);
                value.degrees = result.degrees;
                value.meterText = result.meterText;
            }
        } else if (path.indexOf('rate') > -1) {
            const minValue = this.state.minValue;
            if (value.position) {
                const pos = _.find(this.props.positions, function(pos) {
                    return pos.id == value.position;
                });
                const result = this.changeMeter(value.rate, pos);
                value.degrees = result.degrees;
                value.meterText = result.meterText;
            }
            if (parseFloat(value.rate) <= minValue) {
                arrowDisabled = true;
            }
        } else if (path.indexOf('workers_needed') > -1) {
            value.workers_needed = value.workers_needed.replace(/[^0-9]/g, "");
        }

        this.setState({
            value,
            arrowDisabled
        });

        if (this.props.onChange) {
            this.props.onChange(value, path);
        }
    }

    getOptions() {
        const errors = this.props.errors;
        return {
            auto: 'none',

            template: makeLayout.bind(this),

            fields: {
                position: {
                    nullOption: {value: '', text: 'Choose a position'},
                    options: this.buildSelectOptions(this.props.positions),
                    factory: t.form.Select,
                    attrs: {
                        className: "form-control form-control-select " + (this.state.disabled ? "disabled" : "")
                    },
                    hasError: !!errors,
                    error: errors && errors['position'] ? "Select a position" : null,
                    disabled: this.state.disabled
                },

                workers_needed: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['workers_needed'] ? 'This field is required' : errors['workers'] ? errors['workers'] : null
                },

                rate: {
                    type: 'text',
                    factory: NumberInput,
                    hasError: !!errors,
                    error: errors && errors['hourly_rate'] ? errors['hourly_rate'] : errors['rate'] ? "Add a rate" : errors.errors && Object.keys(errors.errors).indexOf('rate') > -1 ? "Please add a valid number" : null,
                    attrs: {
                        arrowDisabled: this.state.arrowDisabled
                    }
                },

                dresscode: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['dresscode'] ? "Specify a dresscode" : null
                },

                positionDescription: {
                    type: 'hidden'
                },

                meterText: {
                    type: 'hidden'
                },

                degrees: {
                    type: 'hidden'
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

ShiftPositionsForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    positions: React.PropTypes.array.isRequired,
    onChange: React.PropTypes.func
};


export default ShiftPositionsForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ShiftPositionsForm.js
 **/